module.exports = __webpack_public_path__ + "static/media/fifteenth_cleo_rogers_memorial_library.69c560da.mp4";